/**
 * Cosmeau V6 cart helper
 * Ensures product header ATC uses AJAX + Corner Cart instead of native /cart navigation.
 */
(function () {
  if (window.CosmeauV6Cart && window.CosmeauV6Cart.__ready) return;

  const api = (window.CosmeauV6Cart = window.CosmeauV6Cart || {});
  const BOUND = 'cv6CornerCartBound';

  function cartAddUrl() {
    const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js$/i.test(base) ? base : base + '.js';
  }

  function isCornerOpen() {
    const primary = document.getElementById('corner-cowi-open-primary-card');
    if (!primary) return false;
    try {
      return getComputedStyle(primary).opacity === '1';
    } catch (_) {
      return String(primary.className || '').indexOf('opacity-100') !== -1;
    }
  }

  function openCornerCart(params) {
    try {
      if (window.corner && typeof window.corner.do === 'function') {
        window.corner.do('openCart', params);
        return true;
      }
    } catch (_) {}

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return true;
      } catch (_) {}
    }

    try {
      if (window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart) {
        window.Shopify.actions.openCart();
        return true;
      }
    } catch (_) {}

    return false;
  }

  function ensureOpen(retryMs) {
    const delays = Array.isArray(retryMs) ? retryMs : [0, 80, 250, 700, 1400];
    delays.forEach(function (ms) {
      setTimeout(function () {
        if (!isCornerOpen()) openCornerCart();
      }, ms);
    });
  }

  async function refreshAndOpen() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (_) {}
    ensureOpen();
    return true;
  }

  async function addFromForm(form, options) {
    options = options || {};
    if (!form) throw new Error('Missing product form');

    const button =
      options.button ||
      form.querySelector('[type="submit"][name="add"], [data-atc], [data-v6wp-submit], .product-form__submit, button[name="add"]');

    if (button && (button.disabled || button.getAttribute('aria-disabled') === 'true')) {
      return null;
    }

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }

    try {
      const body = new FormData(form);
      if (!body.get('id')) throw new Error('Geen variant geselecteerd');

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
        credentials: 'same-origin',
      });

      let data = null;
      try {
        data = await response.json();
      } catch (_) {
        data = {};
      }

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Toevoegen aan winkelmand mislukt');
      }

      await refreshAndOpen();
      if (typeof options.onSuccess === 'function') options.onSuccess(data);
      return data;
    } catch (error) {
      if (typeof options.onError === 'function') options.onError(error);
      throw error;
    } finally {
      if (button) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      }
    }
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // Only standard single-line PDP header forms. Multi-line configurators
    // (G6 / Geurparels) open Corner Cart in their own AJAX handlers.
    if (
      !form.matches(
        'form[data-type="add-to-cart-form"], form[data-product-form].cv6-default-product-form, form.cv6-default-product-form, form.v6wp-hero__form, form[data-product-form][data-cv6-product-form-host]'
      )
    ) {
      // Also allow plain data-product-form wasparfum / default shells without host attr.
      const isWasparfum = form.matches('form.v6wp-hero__form, form[data-product-form].v6wp-hero__form');
      const isDefault = form.matches('form.cv6-default-product-form, form[data-type="add-to-cart-form"]');
      const isPlainProductForm =
        form.matches('form[data-product-form]') &&
        !form.matches('[data-cv6-g6-product-form], form[data-cv6-skip-corner-bind]') &&
        !form.closest('[data-v6gp], .v6gp, [data-cv6-g6-pdp]');
      if (!(isWasparfum || isDefault || isPlainProductForm)) return;
    }
    if (form.matches('[data-cv6-g6-product-form], form[data-cv6-skip-corner-bind]')) return;
    if (form.closest('[data-v6gp], .v6gp, [data-cv6-g6-pdp]')) return;

    // Capture-phase stop: never allow native navigation to /cart/add → /cart.
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    addFromForm(form, {
      button: form.querySelector('[type="submit"][name="add"], [data-atc], [data-v6wp-submit], .product-form__submit, button[name="add"]'),
    }).catch(function (error) {
      console.error('[CosmeauV6Cart]', error);
    });
  }

  function bindProductForm(form) {
    if (!form || form.dataset[BOUND] === 'true') return;
    form.dataset[BOUND] = 'true';
    // Per-form bubble listener as backup if capture is skipped/stopped earlier.
    form.addEventListener(
      'submit',
      function (event) {
        onSubmit(event);
      },
      false
    );
  }

  function bindAllProductForms(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(
        'form[data-type="add-to-cart-form"], form[data-product-form], form.cv6-default-product-form, form.v6wp-hero__form'
      )
      .forEach(bindProductForm);
  }

  // Global capture once.
  if (!window.__cv6CornerCartCapture) {
    window.__cv6CornerCartCapture = true;
    document.addEventListener('submit', onSubmit, true);
  }

  function boot() {
    bindAllProductForms(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  // Late app/section mounts (Shopify section rendering, DealEasy, etc.)
  setTimeout(boot, 0);
  setTimeout(boot, 800);
  setTimeout(boot, 2500);

  api.open = openCornerCart;
  api.refreshAndOpen = refreshAndOpen;
  api.addFromForm = addFromForm;
  api.bindProductForm = bindProductForm;
  api.bindAllProductForms = bindAllProductForms;
  api.isOpen = isCornerOpen;
  api.ensureOpen = ensureOpen;
  api.__ready = true;
})();
